var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7692 18.7692H18.7692C20.4262 18.7692 21.7692 17.4262 21.7692 15.7692V7.76923C21.7692 6.11223 20.4262 4.76923 18.7692 4.76923H6.76923C5.11223 4.76923 3.76923 6.11223 3.76923 7.76923V15.7692C3.76923 17.4262 5.11223 18.7692 6.76923 18.7692H8.26923V21.7692L12.7692 18.7692Z",
    stroke: "#266EF1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.fa0033ff939b5cd5c0e17e21fe3745c4.svg";
export { ForwardRef as ReactComponent };